import { PlusOutlined } from '@ant-design/icons';
import { Button, Col, Input, message } from 'antd';
import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useQueryClient } from 'react-query';
import { Outlet, useSearchParams } from 'react-router-dom';

import useAPIQuery from '../../api/useAPIQuery';
import Filter from '../../components/Filter';
import {
  RequestJobPostingTemplateTable,
  AddRequestJobPostingTemplate,
} from '../../components/RequestJobPostingTemplate';
import SearchParam from '../../components/SearchParam';
import { withRouteChange } from '../../services/APM';

const RequestJobPostingTemplates = () => {
  const queryClient = useQueryClient();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isAddRequestJobPostingTemplateOpen, setIsAddRequestJobPostingTemplateOpen] =
    useState(false);

  const requestJobPostingTemplates = useAPIQuery([
    '/request-job-posting-templates/',
    {
      params: {
        page: parseInt(searchParams.get('page') || '1', 10),
        page_size: parseInt(searchParams.get('pageSize') || '10', 10),
        ordering: 'name',
        ...(searchParams.get('search') ? { search: searchParams.get('search') as string } : {}),
      },
    },
  ]);

  return (
    <>
      <Helmet>
        <title>Modelos de Requisições de Vagas | Configurações | Recrutamento e Seleção</title>
      </Helmet>
      <Outlet />
      <AddRequestJobPostingTemplate
        open={isAddRequestJobPostingTemplateOpen}
        onSuccess={async () => {
          message.success('Modelo adicionado.');
          await queryClient.invalidateQueries('/request-job-posting-templates/');
          await queryClient.refetchQueries('/request-job-posting-templates/');
          setIsAddRequestJobPostingTemplateOpen(false);
        }}
        onClose={() => setIsAddRequestJobPostingTemplateOpen(false)}
        destroyOnClose
      />
      <Filter>
        <Col flex={1}>
          <SearchParam name="search" onSetSearchParams={{ page: '1' }}>
            <Input.Search allowClear placeholder="Nome do modelo" />
          </SearchParam>
        </Col>
        <Col>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => setIsAddRequestJobPostingTemplateOpen(true)}
          >
            Novo modelo
          </Button>
        </Col>
      </Filter>
      <RequestJobPostingTemplateTable
        loading={{ spinning: requestJobPostingTemplates.isFetching, size: 'large' }}
        dataSource={requestJobPostingTemplates.data?.results ?? []}
        pagination={{
          total: requestJobPostingTemplates.data?.count,
          onChange: (page, pageSize) => {
            searchParams.set('page', page.toString());
            searchParams.set('pageSize', pageSize.toString());
            setSearchParams(searchParams);
          },
          current: parseInt(searchParams.get('page') || '1', 10),
          pageSize: parseInt(searchParams.get('pageSize') || '10', 10),
        }}
        searchParams={searchParams}
      />
    </>
  );
};

export default withRouteChange()(RequestJobPostingTemplates);
